<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="17">
        <el-card shadow="never">
          <div class="clearfix topwidget">
            <div class="img pull-left">
              <img :src="info.content.image" :alt="info.title">
            </div>

            <div class="meta pull-left">
              <div class="title">{{ info.title }}</div>
              <div class="desc">{{ info.content.desc }}</div>
              <div class="tags">
                <el-tag class="tag" size='small'>{{ info.content.tags[0].title }}</el-tag>
                <el-tag class="tag" size='small'>{{ info.content.tags[1].title }}</el-tag>
              </div>
            </div>
          </div>
        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">游戏介绍</span>
          </template>

          <div class="describe" v-html="info.content.describe"></div>

          <!-- 游戏截图 -->
          <div class="game-images">
            <a :href="item" v-for="(item, idx) in info.content.imgs" :key="idx" class="img-block">
              <img :src="item" alt="">
            </a>
          </div>

          <!-- 游戏福利 -->
          <div style="margin-bottom: 15px">
            <div class="article-head">
              <div class="title">游戏福利</div>
            </div>
            <div v-html="info.content.welfare"></div>
          </div>

          <!-- 游戏返利 -->
          <div>
            <div class="article-head">
              <div class="title">游戏返利</div>
            </div>
            <div v-html="info.content.rebate"></div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="7">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">开服表</span>
          </template>

          <div class="services">
            <ul>
              <li class="clearfix service-item" v-for="(item, idx) in info.content.services" :key="idx">
                <span v-if="item.date" class="tag">{{ item.date }}</span>
                <span v-if="item.time" class="time">{{ item.time }}</span>
                <span class="name">{{ item.name }}</span>
              </li>
            </ul>
          </div>

        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">相关资讯</span>
          </template>
          
          <list />
        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">热门排行</span>
          </template>
          
          <hot-list />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    const id = this.$route.params.id
    let info = null
    if(this.$route.query.type == 1) {
      info = this.$datas.bannerList.find(c => c.id == `/${id}/`)
    } else {
      info = this.$datas.serviceList.find(c => c.id == `/${id}/`)
    }
    return {
      info: info,
      bannerList: this.$datas.bannerList,
      serviceList: this.$datas.serviceList,
    }
  }
}
</script>

<style lang="scss">
$imgSize: 120px;
.topwidget {
  .img {
    width: $imgSize;
    height: $imgSize;
  }
  .meta {
    padding-left: 15px;
    .title { font-size: 30px; color: var(--theme); margin-bottom: 10px; }
    .tag { margin-right: 10px; }
  }
}  
.services {
  .service-item {
    display: flex;
    height: 25px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    &:last-child { margin-bottom: 0; }
    .tag {
      display: inline-block;
      width: 65px;
      height: 25px;
      line-height: 25px;
      border-radius: 5px;
      text-align: center;
      font-size: 13px;
      margin-right: 10px;
      background-color: var(--theme);
      color: #fff;
    }
    .time, .name {
      font-weight: bold;
      font-size: 15px;
    }
    .name {}
  }
}

.game-images {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
  .img-block {
    width: 155px;
  }
}
.article-head {
  margin-bottom: 7px;
  padding-bottom: 5px;
  border-bottom: 1px solid #dedede;
  .title {
    font-size: 16px;
    color: var(--theme);
    font-weight: bold;
    border-left: 2px solid var(--theme);
    text-indent: 5px;
  }
}

.desc {
  margin-bottom: 10px;
  font-size: 15px;
  color: #636363;
}
</style>
